export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pdfWorker.b415fd71.worker.js");
}
